/**
 * FILTRO POR MARKETPLACE EN PÓLIZAS (Lissette 2026-09-29).
 *
 * *"Poder colocar en el módulo de póliza un filtro por tipo de mercado de
 * salud"*, que *"se habilitaría cuando coloque el tipo de seguro salud"*. El
 * dato ya existe: es el "Nombre del Marketplace" de la ficha de la póliza de
 * salud (`marketplaceName`: HealthCare.gov, Covered California, los propios de
 * la agencia…). Aquí no se inventa ningún campo nuevo.
 *
 * `SIN_MARKETPLACE` agrupa las pólizas que no lo tienen escrito. Sin esa
 * opción, al elegir uno, las que faltan por rellenar desaparecen de la vista
 * sin que se note que existen, que es justo el filtro que esconde filas.
 */
export const SIN_MARKETPLACE = '\u0000__sin_marketplace__';

const clave = (v) => String(v ?? '').trim().toLowerCase();

/** ¿Esta póliza pasa el filtro? "all" (o vacío) no filtra. */
export function pasaElFiltroDeMarketplace(poliza, filtro) {
  if (!filtro || filtro === 'all') return true;
  const propio = clave(poliza?.marketplaceName);
  if (filtro === SIN_MARKETPLACE) return !propio;
  return propio === clave(filtro);
}

/**
 * Las opciones del filtro: los marketplaces que de verdad aparecen en estas
 * pólizas, sin repetir mayúsculas/espacios, con su cuenta. Las que no lo
 * tienen escrito van al final como SIN_MARKETPLACE.
 */
export function opcionesDeMarketplace(polizas) {
  const cuenta = new Map();
  let sin = 0;
  for (const p of polizas || []) {
    const n = String(p?.marketplaceName ?? '').trim();
    if (!n) { sin += 1; continue; }
    const k = clave(n);
    const prev = cuenta.get(k);
    if (prev) prev.cuenta += 1; else cuenta.set(k, { valor: n, cuenta: 1 });
  }
  const lista = [...cuenta.values()].sort((a, b) => a.valor.localeCompare(b.valor));
  if (sin) lista.push({ valor: SIN_MARKETPLACE, cuenta: sin });
  return lista;
}
